/**
 * @file Constants relating to Transactions.
 */

/**
 * Transaction types.
 *
 * @enum {{PHOTO: string, SUBSCRIPTION: string}}
 */
export const TRANSACTION_ITEM_TYPE = {
  PHOTO: 'PHOTO',
  SUBSCRIPTION: 'SUBSCRIPTION',
  CUSTOM_PRINT: 'CUSTOM_PRINT',
  DIGITAL_BUNDLE: 'DIGITAL_BUNDLE',
};

/**
 * Transaction labels.
 *
 * @enum {{PHOTO: string, SUBSCRIPTION: string}}
 */
export const TRANSACTION_ITEM_LABEL = {
  PHOTO: 'Photo',
  SUBSCRIPTION: 'Subscription',
  CUSTOM_PRINT: 'Custom Print',
  DIGITAL_BUNDLE: 'Digital Bundle',
};

/**
 * Subscription Related transaction types.
 *
 * @enum {{ALBUM_FOLDER: string, ALBUM: string}}
 */
export const SUBSCRIPTION_ITEM_TYPE = {
  ALBUM_FOLDER: 'ALBUM_FOLDER',
  ALBUM: 'ALBUM',
};

/**
 * Photo Related transaction types.
 *
 * @enum {{PRINT: string, DOWNLOAD: string, PRINT_PACKAGE: string, PHOTO_PRICING: string}}
 */
export const PHOTO_ITEM_TYPE = {
  PRINT: 'PRINT',
  DOWNLOAD: 'DOWNLOAD',
  PRINT_PACKAGE: 'PRINT_PACKAGE',
  PHOTO_PRICING: 'PHOTO_PRICING',
  PRINT_PRODUCT: 'PRINT_PRODUCT',
};

/**
 * Custom Print Item Type.
 *
 * @enum {{ALBUM_FOLDER: string, ALBUM: string}}
 */
export const CUSTOM_PRINT_ITEM_TYPE = {
  ALBUM_FOLDER: 'ALBUM_FOLDER',
  ALBUM: 'ALBUM',
};

/**
 * Album Folder Account filters.
 *
 * @enum {{WITH_ALBUM_MEMBERSHIPS: string, WITH_TRANSACTION_ITEMS: string}}
 */
export const ACCOUNTS_FILTER = {
  WITH_ALBUM_MEMBERSHIPS: 'WITH_ALBUM_MEMBERSHIPS',
  WITH_TRANSACTION_ITEMS: 'WITH_TRANSACTION_ITEMS',
};

/**
 * Album Account filters.
 *
 * @enum {{WITH_ALBUM_MEMBERSHIPS: string, WITH_TRANSACTION_ITEMS: string}}
 */
export const ALBUM_ACCOUNTS_FILTER = {
  WITH_ALBUM_MEMBERSHIP: 'WITH_ALBUM_MEMBERSHIP',
  WITH_TRANSACTION_ITEMS: 'WITH_TRANSACTION_ITEMS',
};

export const ACCOUNTS_LIMIT = 25;

export const TRANSACTIONS_LIMIT = 25;

export const TRANSACTIONS_CUTOFF_DATE = '2022-09-01';
